import { render, staticRenderFns } from "./ConflictCommentComparedDialog.vue?vue&type=template&id=484ed62c&scoped=true&"
import script from "./ConflictCommentComparedDialog.vue?vue&type=script&lang=ts&"
export * from "./ConflictCommentComparedDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConflictCommentComparedDialog.vue?vue&type=style&index=0&id=484ed62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ed62c",
  null
  
)

export default component.exports